import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/hooks';
import { logout } from '@/store/slices/authSlice';
import { getRexSSOLoginUrl } from '@/api/core/apiConfig';
import { useSSOLinkAccount } from '@/hooks/account/useSSOLinkAccount';
import { SSOLinkAccountForm, SSOLinkSuccessForm } from '@/components/features/account/ssoLinkAccount';
import { LoginLayout } from '@/components/layout';


type SSOLinkView = 'form' | 'success';

const SSOLinkAccount: React.FC = () => {
  const { t: translate } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [view, setView] = useState<SSOLinkView>('form');

  const handleBackToHome = useCallback(() => {
    void navigate('/', { replace: true });
  }, [navigate]);

  const handleSuccess = useCallback(() => {
    setView('success');
  }, []);

  const {
    register,
    handleSubmit,
    errors,
    isSubmitting,
    isLoadingInfo,
    userNameTaken,
  } = useSSOLinkAccount(handleSuccess);

  const handleRedirect = useCallback(() => {
    dispatch(logout());
    window.location.href = getRexSSOLoginUrl();
  }, [dispatch]);

  const title = view === 'success'
    ? translate('auth:ssoLinking.success.title')
    : translate('auth:ssoLinking.form.title');

  return (
    <LoginLayout title={title}>
      {view === 'form' ? (
        <SSOLinkAccountForm
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
          isSubmitting={isSubmitting}
          isLoadingInfo={isLoadingInfo}
          userNameTaken={userNameTaken}
          onBackToHome={handleBackToHome}
        />
      ) : (
        <SSOLinkSuccessForm onRedirect={handleRedirect} />
      )}
    </LoginLayout>
  );
};

export default SSOLinkAccount;
